import I18n from "@helper/i18nInstance"
import React from "react"
import "./RaffleHolder.scss"

const RaffleHolder: React.FC<React.PropsWithChildren<{raffleOver?: boolean, testId?: string}>> = ({ children, raffleOver, testId }) => {
  return <div className="neo__raffleHolder" data-testid={testId}>
    <div>
      <h2 className="neo__raffleHolder__title">{I18n.t(raffleOver ? "raffle.title_raffle--over" : "raffle.title_raffle")}</h2>
      <div className="neo__raffleHolder__inner">
        {children}
      </div>
    </div>
  </div>
}

export default RaffleHolder
